export default {
  home: {
    minute: 'Minute',
    shopdesc: 'Der Tagessatz ist auf {currencyName}{fengding} pro Tag begrenzt',
    feature_1: 'Bringe es zu einer beliebigen Rechargy Station zurück',
    feature_2: 'USB C, Lightning, Micro USB und kabellos inkl.',
    feature_3: 'Empfehle es einem Freund/einer Freundin und erhalte eine kostenlose Mietzeit.',
    tips_1: 'Eine Kaution von {currencyName}{fengding} muss vor der Anmietung aufgeladen werden, wenn das Guthaben nicht ausreichend ist',
    tips_2: 'Aufladekaution von {currencyName}{fengding} kann benutzt werden, verbrauchtes kann zurückerstattet werden',
    tips_3: 'Das aktuelle Guthaben beträgt {currencyName}{fengding}, welches direkt benutzt werden kann',
    submit: 'Aufladen',
    borrow: 'Mieten',
    beginrental: 'Miete beginnen',
    msg_fail_title: 'Fehler',
    msg_rentcount: 'Du hast derzeit {zujieNum} einen unabgeschlossenen Auftrag',
    msg_fail_content: 'Miete fehlgeschlagen, bitte versuche es erneut',
    goborrow: 'Jetzt laden!!!',
    nearby: 'Stationen in der Nähe anzeigen',
    joinus: 'Werde Partner',
    download: 'Herunterladen',
    start_renting: 'Miete Starten',
    unlock_powerbank: 'Schalte deine Powerbank frei!',
    agreement_title: 'Marketing-Einwilligung erforderlich',
    agreement_content: 'Um eine Powerbank zu mieten, müssen Sie Ihre E-Mail-Adresse oder Telefonnummer eingeben und der Nutzung Ihrer Daten zu Marketingzwecken zustimmen. Wenn Sie auf „Ja“ tippen, können Sie mit dem Mietvorgang fortfahren. Wenn Sie auf „Nein“ tippen, wird der Mietvorgang abgelehnt und Sie müssen den QR-Code erneut scannen.',
    agreement_state: 'Ich stimme zu, dass meine Daten zu Marketingzwecken verwendet werden dürfen.',
    agreement_no: 'Nein',
    agreement_yes: 'Ja',
    agreement_check: 'Bitte kreuzen Sie das Kästchen an, um der Vereinbarung zuzustimmen.'
  },
  login: {
    emaillogin: 'E-Mail-Anmeldung',
    email: 'Postfach',
    phonelogin: 'Login mit Telefonnummer',
    code_title: 'SMS Verifikation',
    phone_number: 'Telefonnummer',
    verification_code: 'Bitte SMS-Verifizierungscode eingeben',
    verification_check_spam: 'überprüfe dein Spam Ordner',
    captcha_code: 'Code',
    send_code: 'Code senden',
    login: 'Anmelden',
    and: 'und',
    agree: 'Durch das Klicken auf Anmelden, erklärst du dich einverstanden mit',
    readme: `Benutzervereinbarung`,
    privacy: 'Datenschutzvereinbarung',
    msg_fail_login: 'Anmeldung fehlgeschlage',
    msg_success_login: 'Anmeldung erfolgreich',
    msg_fail_user: 'Fehler beim Abrufen von Benutzerinformationen. Möchtest du es erneut versuchen?',
    sign_in_with: 'Anmelden mit',
    no_sms: 'Ich habe keine Nachricht erhalten',
    retry: 'Erneut senden'
  },
  confirm: {
    title: 'Zahlungsbestätigung',
    pay_label: 'Betrag',
    auth_label: 'Vorautorisierung',
    price_tips: 'Ihr Guthaben kann auf Wunsch gutgeschrieben werden. Es kann 1-5 Werktage dauern, bis es auf Ihrem Zahlungskonto erscheint.',
    pay_type: 'Bitte wähle deine bevorzugte Zahlungsmethode aus',
    submit: 'Zahlung bestätigen ',
    msg_loading: 'Lädt...',
    msg_fail_title: 'Warnung',
    msg_fail_payment: 'Kautionszahlung konnte nicht durchgeführt werden',
    msg_fail_order: 'Mietauftrag fehlgeschlagen',
    msg_fail_support: 'Das System wird nicht unterstützt',
    msg_fail_confirm: 'Bestätigen',
    msg_fail_retry: 'Erneut versuchen',
    msg_fail_cancel: 'Abbrechen'
  },
  mine: {
    title: 'Benutzerprofil',
    wallet: 'Meine Zahlungen',
    balance: 'Mein Guthaben',
    deposit: 'Kaution',
    order: 'Auftrag',
    coupon: 'Coupon',
    login_tips: 'Bitte anmelden ',
    msg_fail_title: 'Fehler',
    msg_fail_update: 'Aktualisierung fehlgeschlagen, bitte versuche es erneut',
    msg_loading: 'Lädt...',
    msg_fail_user: 'Fehler beim Abrufen von Benutzerinformationen. Möchtest du es erneut versuchen?',
    help: 'Hilfe',
    setting: 'Einstellungen',
    logout: 'Abmelden',
    payment: 'Zahlung'
  },
  msg: {
    msg_fail_phone: 'Bitte geben Sie Ihre Telefonnummer ein',
    msg_fail_email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    msg_fail_title: 'Warnung',
    loading: 'Lädt...',
    title: 'Hinweis',
    success: 'Erfolgreiche Durchführung',
    error: 'Unbekannter Fehler, bitte versuche es später erneut.',
    roleerror: 'Unzureichende Berechtigungen, bitte wende dich an den Administrator',
    neterror: 'Netzwerk Verbindung fehlgeschlagen. Bitte versuche es später erneut',
    deletecard: 'Bist du dir sicher, dass du die Karte entfernen möchtest?',
    confirm: 'Bestätigen',
    retry: 'Erneut versuchen',
    cancel: 'Abbrechen',
    title_fail: 'Warnung',
    vieworder: 'Auftrag ansehen',
    success_payment: 'Zahlung abgeschlossen',
    fail_payment: 'Zahlung fehlgeschlagen',
    keyword: 'Stichwort',
    '正式订单已生成': 'Offizieller Auftrag wurde erstellt'
  },
  result: {
    title: 'Ergebnisbestätigung',
    price_plan: 'Gebührenordnung',
    msg_success: 'Erfolgreich gemietet',
    msg_tips_loading: 'Powerbank kommt heraus, bitte warten...',
    msg_result_loading: 'Die Zahlung wird bestätigt...',
    msg_fail_confirm: 'Bestätigen',
    btn_usage: 'Benutzerhinweis',
    btn_return: 'Rückgabehinweis',
    deposit: 'Kaution',
    msg_fail_content: 'Anfrage fehlgeschlagen, bitte versuche es erneut',
    price_label: 'pro Stunde',
    price_info: 'Die ersten {mianfei} Minuten sind kostenlos, die maximale Gebühr beträgt {ccurrency}{fengding}, die Kaution wird automatisch abgebucht, wenn die Miete beginnt {ccurrency}{yajin}',
    tips_1: 'Bitte entnehme die Powerbank <span class="number">No.{number}</span>, wie auf dem Bild angezeigt',
    tips_2: 'Bitte ordnen Sie die Kabel und legen Sie die Powerbank bei der Rückgabe mit dem Pfeil nach unten ein',
    msg_note_usage: 'Die Powerbank ist mit 3 Arten von Kabeln und kabelloses Laden ausgestattet, bitte benutze eins nach Bedarf.",.',
    msg_note_return: 'Bitte ordnen Sie die Kabel und stecken Sie die Powerbank bei der Rückgabe mit dem Pfeil nach unten in die Station..',
    return_info: 'Nach der Rückkehr die Kabel gut befestigen und die Seite mit den Metallspänen in eine leere Station stecken, bis sie den Boden erreicht und stabili',
    vieworder: 'Auftrag ansehen',
    gohome: 'Startseite'
  },
  result_msg: {
    loading: 'Lädt...',
    refresh: 'Aktualisieren'
  },
  order: {
    title: 'Mietauftrag',
    in_use: 'In Verwendung',
    ended: 'Beendet',
    msg_error: 'Anfrage fehlgeschlagen'
  },
  order_item: {
    order_number: 'No.',
    venue_rented: 'Gemietete Station',
    time_rented: 'Mietzeit',
    venue_returned: 'Zurückgegebene Station',
    time_returned: 'Zurückgegebene Zeit',
    charge_standard: 'Gebührenordnung',
    charge_standard_info: ' {pJifei} {pCurrency} pro 30 min',
    rent_occurred: 'Miete erfolgt',
    returned: 'Zurückgegeben',
    unreturned: 'Nicht Zurückgegeben',
    type_0: 'Nicht abgeschlossen',
    type_1: 'Mieten',
    type_2: 'Abgebrochen',
    type_3: 'Zurückgegeben',
    type_4: 'Fehler aufgetreten',
    type_5: 'Überzeit',
    min: 'Min'
  },
  setting: {
    title: 'Einstellungen',
    lang: 'Sprache'
  },
  help: {
    title: 'FAQ'
  },
  wallet_card: {
    title: 'Bezahlmethode hinzufügen',
    addcard: 'Kreditkarte hinzufügen',
    newcard: 'Neue Karte hinzufügen',
    paypal: 'Paypal hinzufügen',
    savenow: 'Speichern',
    savecard: 'Alle gespeicherten Methoden',
    savedic: 'Bitte Methode hinzufügen',
    msg_fail_title: 'Warnung',
    msg_fail_order: 'Miete fehlgeschlagen',
    msg_fail_confirm: 'Bestätigen',
    msg_fail_retry: 'Erneut versuchen',
    msg_fail_cancel: 'Abbrechen',
    delete: 'Entfernen'
  },
  map: {
    title: 'Stationen in der Nähe',
    result_msg: 'Keine Station in der Nähe gefunden',
    msg_title: 'Fehler',
    no_support: 'Entschuldigung! Dein Browser unterstützt nicht den Standort',
    my_position: 'Mein Standort',
    distance: 'von dir:',
    shop_time: 'Geschäftszeiten',
    free: 'Verfügbar',
    return: 'Rückgabe',
    shop_title: 'Geschäftsdetails',
    address: 'Adresse',
    go_here: 'Hierhin gehen'
  }
}
